import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abmacopios-filter',
  templateUrl: './abmacopios-filter.component.html',
  styleUrls: ['./abmacopios-filter.component.scss']
})
export class ABMAcopiosFilterComponent implements OnInit {

  public showFilters = false;

  constructor() { }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();
  }

  cleanFilters(e) {
    this.onApply(e);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmacopios-filter/abmacopios-filter.component.ts